import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AvanoButtonModule } from '@avano/avano-components/avano-button/avano-button.module';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { ValidationModule } from '../avano-validation/validation.module';
import { AvanoDirectivesModule } from '../directives/avano-directives.module';
import { AvanoUnsavedChangesComponent } from './avano-unsaved-changes.component';

@NgModule({
  imports: [
    CommonModule, TranslateModule.forChild({ extend: true }),
    DialogModule, CheckboxModule, FormsModule,
    AvanoButtonModule, AvanoDirectivesModule,
    ValidationModule
  ],
  declarations: [AvanoUnsavedChangesComponent],
  exports: [AvanoUnsavedChangesComponent],
  providers: []
})
export class AvanoUnsavedChangesModule { }
